export default function isMobileBrowser() {
  return !window ? false : window.innerWidth <= 800;
}
